import React, { memo } from 'react';
import cn from 'classnames';
import Collapse from '../../../../shared/ui/Collapse';
import PanelHeader from './PanelHeader';
import { createPeriod } from '../../../../shared/packages/dateTime';
import PanelContent from './PanelContent';
import {
  createAcceptanceSummary,
  parseAcceptanceSlug,
} from '../../../../shared/packages/acceptance';
import { useItemClick } from './hooks/itemClick';
import { useSearchParamsSelector } from '../../../../shared/packages/searchParamsManager';
import {
  searchParamKeys,
  searchParamSelectors,
} from '../../../../shared/configs/searchParams';
import { useAcceptanceListInfo } from '../../../../services/queries/acceptanceData';
import FetchDataWrapper from '../../../../../../components/FetchDataWrapper';
import { RenderPropsProvider } from './services/renderPropsProvider';
import DownloadSummarySlot from './DownloadSummarySlot';
import styles from './index.module.scss';

const { Panel } = Collapse;

const AcceptanceViewInfo = ({ renderActions }) => {
  const { data, isFetching, refetch } = useAcceptanceListInfo();

  const onItemClick = useItemClick();

  return (
    <FetchDataWrapper
      data={data}
      isFetching={isFetching}
      refetch={refetch}
      errMsg="Произошла ошибка при загрузке информации о приемках"
    >
      <RenderPropsProvider renderActions={renderActions}>
        <Collapse expandIconPosition="right">
          {Array.isArray(data) &&
            data.map((info) => (
              <CollapsePanelWrapper
                key={info.id}
                info={info}
                onNameClick={onItemClick}
              />
            ))}
        </Collapse>
      </RenderPropsProvider>
    </FetchDataWrapper>
  );
};

export default AcceptanceViewInfo;

const MemoizedPanel = memo(CollapsePanel);
function CollapsePanelWrapper({ info, ...props }) {
  const acceptanceSlug = useSearchParamsSelector(
    searchParamSelectors[searchParamKeys.acceptance]
  );

  const { acceptanceId } = parseAcceptanceSlug(acceptanceSlug);

  return (
    <MemoizedPanel
      info={info}
      selected={acceptanceId === info.id}
      clickable={acceptanceSlug !== `${info.id}`}
      {...props}
    />
  );
}

function CollapsePanel({ info, selected, clickable, onNameClick, ...props }) {
  const { id, name, countAddresses, countAcceptanceAddresses, houses } = info;

  return (
    <Panel
      {...props}
      className={cn(styles.panel, { [styles.selected]: selected })}
      header={
        <PanelHeader
          title={name}
          subtitle={createPeriod(info.fromDate, info.toDate)}
          actionsSlot={<DownloadSummarySlot acceptanceId={id} />}
          onTitleClick={
            clickable
              ? (e) => {
                  e.stopPropagation();
                  onNameClick({ acceptanceId: id });
                }
              : undefined
          }
          selected={selected}
        />
      }
    >
      <PanelContent
        result={createAcceptanceSummary(
          countAcceptanceAddresses,
          countAddresses
        )}
        houses={houses}
        acceptanceId={id}
      />
    </Panel>
  );
}
